import BaseModal from './baseModal';

export default class GlobalModal extends BaseModal {
  constructor() {
    super('global-modal-bg', 'global-modal');
    this.modalShown = false;
    this.didomiModalIsVisible = false;
    if (this.modal) {
      this.init();
    }
  }

  init() {
    super.init();

    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push((Didomi) => {
      this.didomiModalIsVisible = Didomi.notice.isVisible();
      this.logic();
    });
  }

  logic() {
    this.modalShown = this.getCookie();

    if (!this.modalShown && !this.didomiModalIsVisible) {
      this.show();
      this.setCookie();
    }
  }

  getCookie() {
    const name = 'common-modal-shown' + '=';
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        // this.modalShown = c.substring(name.length, c.length);
        return true;
      }
    }
    return false;
  }

  setCookie() {
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = 'common-modal-shown=1;' + expires + ';path=/';
  }
}
